"use strict";

var _regeneratorRuntime = require("/app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;

var _toConsumableArray = require("/app/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass.js").default;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var DLList, Sync;
DLList = require("./DLList");

Sync = /*#__PURE__*/function () {
  function Sync(name, Promise) {
    _classCallCheck(this, Sync);

    this.schedule = this.schedule.bind(this);
    this.name = name;
    this.Promise = Promise;
    this._running = 0;
    this._queue = new DLList();
  }

  _createClass(Sync, [{
    key: "isEmpty",
    value: function isEmpty() {
      return this._queue.length === 0;
    }
  }, {
    key: "_tryToRun",
    value: function _tryToRun() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var args, cb, error, reject, resolve, returned, task, _this$_queue$shift;

        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this._running < 1 && _this._queue.length > 0)) {
                  _context2.next = 13;
                  break;
                }

                _this._running++;
                _this$_queue$shift = _this._queue.shift();
                task = _this$_queue$shift.task;
                args = _this$_queue$shift.args;
                resolve = _this$_queue$shift.resolve;
                reject = _this$_queue$shift.reject;
                _context2.next = 9;
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return task.apply(void 0, _toConsumableArray(args));

                        case 3:
                          returned = _context.sent;
                          return _context.abrupt("return", function () {
                            return resolve(returned);
                          });

                        case 7:
                          _context.prev = 7;
                          _context.t0 = _context["catch"](0);
                          error = _context.t0;
                          return _context.abrupt("return", function () {
                            return reject(error);
                          });

                        case 11:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 7]]);
                }))();

              case 9:
                cb = _context2.sent;
                _this._running--;

                _this._tryToRun();

                return _context2.abrupt("return", cb());

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }, {
    key: "schedule",
    value: function schedule(task) {
      var promise, reject, resolve;
      resolve = reject = null;
      promise = new this.Promise(function (_resolve, _reject) {
        resolve = _resolve;
        return reject = _reject;
      });

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this._queue.push({
        task: task,
        args: args,
        resolve: resolve,
        reject: reject
      });

      this._tryToRun();

      return promise;
    }
  }]);

  return Sync;
}();

module.exports = Sync;